import type { SvgIconProps } from './types';

export function AppointmentBookingIcon(props: SvgIconProps) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth={0.4} viewBox="0 0 16 16" height="1em" width="1em" {...props}>
      <path d="M12 1H4C3.45 1 3 1.45 3 2V14C3 14.55 3.45 15 4 15H12C12.55 15 13 14.55 13 14V2C13 1.45 12.55 1 12 1ZM11 2V0H5V2H11ZM4 14V3H12V14H4ZM8 9V4H9V8H11L8 11L5 8H7V9H8Z" />
    </svg>
  );
}
